import React from 'react';

interface LogoProps {
  color?: string;
  display?: boolean;
}

const Logo = (props: LogoProps) => {
  const color = props.color || '#019ada';

  return (
    <svg
      className="glance-logo"
      id="uuid-3dcb1d1f-954e-41f3-87a8-da702614a98d"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 191 294"
    >
      <rect
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        x="105"
        y="105"
        width="84"
        height="84"
      />
      <path
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        d="m105,209h84c0,46.361-37.639,84-84,84h0v-84h0Z"
      />
      <path
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        d="m105,1h0c46.361,0,84,37.639,84,84h-84V1h0Z"
      />
      <path
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        d="m1,105h84v84h0C38.639,189,1,151.361,1,105h0Z"
      />
      <path
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        d="m1,209h84v84h0c-46.361,0-84-37.639-84-84h0Z"
      />
      <path
        className="uuid-872a4a21-0cac-4dba-9ba0-c09d2a317485"
        fill={color}
        d="m85,1h0v84H1C1,38.639,38.639,1,85,1Z"
      />
    </svg>
  );
};

export default Logo;
